import type { Page } from "../../../../common/types/base/BaseEntity";
import httpRequest from "./index";
import { BaseService } from "@/api/baseService";
import type { ProductVo } from "@zhihaoscm/entity";
import { isChainCloudTenant } from "@/api/legacy";

class ProductService extends BaseService<any, any, any, any> {
    public async productPage(params: any): Promise<Page<ProductVo>> {
        const enum isPCWeb {
            IS_PC = 1
        }
        params.isCustomPC = isPCWeb.IS_PC;
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    // 不区分身份版
    public async productPageRelated(params: any): Promise<Page<ProductVo>> {
        const enum isPCWeb {
            IS_PC = 1
        }
        params.isCustomPC = isPCWeb.IS_PC;
        const { data } = await this.service.get(`${this.path}/related-paging`, { params });
        return data;
    }

    public async productPageAll(params: any): Promise<Page<ProductVo>> {
        return isChainCloudTenant() ? await this.productPageRelated(params) : await this.productPage(params);
    }

    public async getInfo(id: number) {
        const { data } = await this.service.get(`${this.path}/vo?id=${id}`);
        return data;
    }
}

export const productService = new ProductService("/product", httpRequest);
